export default function maskPhoneNumber(phone) {
  var visibleDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (!phone) return '';
  var len = phone.length;
  if (len <= visibleDigits) return phone;
  var maskedLength = len - visibleDigits;
  return "".concat('*'.repeat(maskedLength)).concat(phone.slice(-visibleDigits));
}